import { useSelector } from "react-redux";
import { RootState } from "../../state";

import { Shirt } from "../../entities/Shirt";
import ShirtDetailView from "../ShirtDetailView/ShirtDetailView";
import ShirtDetailOwner from "../ShirtDetailOwner/ShirtDetailOwner";

interface ShirtDetailProps {
  shirt: Shirt;
}

const ShirtDetail = ({ shirt }: ShirtDetailProps) => {
  const loginData = useSelector((state: RootState) => state.login);

  return loginData.userId === shirt.owner.id ? (
    <ShirtDetailOwner shirt={shirt} />
  ) : (
    <ShirtDetailView shirt={shirt} />
  );
};

export default ShirtDetail;
